export default {
  name: 'd2-vnode',
  functional: true,
  props: {
    render: Function
  },
  render: function render(h, ctx) {
    return ctx.props.render(h);
  }
};